import {Badge, Nav} from 'react-bootstrap';
import {Info} from 'lucide-react';
import {useChat} from './ChatProvider';

export default function ChatNavItem() {
    const {unreadCount, unreadStatus, error} = useChat();
    const statusMessage = error?.code === 'CHAT_DISABLED'
        ? 'Chat is not enabled in this environment'
        : 'Unread synchronization delayed';
    return <Nav.Item as="li">
        <Nav.Link href="/chat" className="position-relative" title={unreadStatus !== 'ready' ? statusMessage : undefined}>
            <span className="position-relative d-inline-flex align-items-center gap-1" style={{paddingRight: '8px'}}>
                Chat
                {unreadStatus !== 'ready' ? (
                    <span className="d-inline-flex text-secondary" role="status" aria-label={statusMessage}>
                        <Info size={14} aria-hidden="true" />
                    </span>
                ) : null}
                {unreadCount > 0 ? <Badge bg="danger" pill aria-label={`${unreadCount} unread chat items`} style={{position: 'absolute', top: '-10px', right: '-10px', fontSize: '10px', minWidth: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 0 2px white', backgroundColor: '#dc3545'}}>{unreadCount}</Badge> : null}
            </span>
        </Nav.Link>
    </Nav.Item>;
}
